import { render, staticRenderFns } from "./ActionOverlay.vue?vue&type=template&id=16ffcabf&"
import script from "./ActionOverlay.vue?vue&type=script&lang=js&"
export * from "./ActionOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports